import { type FunctionComponent, useState } from 'react';

import { Button, Dropdown } from '@dr.pogodin/react-utils';

import { useOutput } from 'hooks/audio';

import S from './style.scss';
import dropdownTheme from '../dropdown.scss';

type PropsT = {
  devices: MediaDeviceInfo[];
  setOutputByLabel: (label: string) => void;
};

export const AudioOutput: FunctionComponent<PropsT> = ({
  devices,
  setOutputByLabel,
}) => {
  const output = useOutput();

  const [edit, setEdit] = useState(false);

  return (
    <div className={S.container}>
      {edit ? (
        <Dropdown
          label="Output"
          onChange={(e) => {
            setOutputByLabel(e.target.value);
            setEdit(false);
          }}
          onClick={() => {
            setEdit(false);
          }}
          options={devices.map((item) => item.label)}
          theme={dropdownTheme}

          // NOTE: `output.label` might be an empty string, and we cannot
          // just default it to "Default", as we use this label to find
          // selected device in the setOutputByLabel() method, triggered
          // when this dropdown is used.
          value={output.label || 'Default'}
        />
      ) : (
        <>
          <div className={S.label}>Output</div>
          <div styleName="value">{output.label || 'Default'}</div>
          <Button
            onClick={() => {
              setEdit(true);
            }}
          >
            Change
          </Button>
        </>
      )}
    </div>
  );
};
